import { Divider, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
  UseFormSetValue,
} from "react-hook-form";

interface ParametersProps {
  control?: Control<any>;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  noteId?: string;
  setValue: UseFormSetValue<any>;
  onCancel: () => void;
}

const ParametersViewDrawer: React.FC<ParametersProps> = ({
  control,
  id,
  register,
  noteId,
  reset,
  setValue,
  onCancel,
}) => {
  useEffect(() => {
    return () => {
      reset();
    };
  }, []);
const items = [
  "WBC (White Blood Cells)",
  "Neutrophils",
  "Lymphocytes",
  "Monocytes",
  "Eosinophils",
  "Basophils",
  "RBC (Red Blood Cells)",
  "Hemoglobin (HGB)",
  "Hematocrit (HCT / PCV)",
  "MCV (Mean Corpuscular Volume)",
  "MCH (Mean Corpuscular Hemoglobin)",
  "MCHC (Mean Corpuscular Hemoglobin Concentration)",
  "RDW-CV (Red Cell Distribution Width – Coefficient of Variation)",
  "RDW-SD (Red Cell Distribution Width – Standard Deviation, if reported)",
  "Platelet Count (PLT)",
  "MPV (Mean Platelet Volume)",
  "Platelet Distribution Width (PDW) [optional but often included]",
  "Absolute Leucocyte Count (ALC)",
  "Absolute Neutrophil Count (ANC)",
  "Absolute Lymphocyte Count (ALymphC)",
  "Absolute Monocyte / Eosinophil / Basophil count",
];

  return (
    <Grid  sx={{
        border: "1px solid #828584",
        backgroundColor: "#EAF0EE",
        borderRadius: "8px",
        padding: "16px",
      }}><Grid container spacing={2} mt={2}>
  <Grid item xs={12}>
    <ul style={{ margin: 0, paddingLeft: "20px" }}>
      {items.map((item, index) => (
        <li key={index}>
          <Typography component="span" style={{color:"#828584"}}>{item}</Typography>
        </li>
      ))}
    </ul>
  </Grid></Grid>
    
</Grid>

  );
};
export default ParametersViewDrawer;
